import React, { useState } from "react";
import "./Products.css";
import { Link } from "react-router-dom";
import { GraduationCap, BookOpen, Cpu, Settings, ArrowRight, X, Megaphone } from "lucide-react";
import SEO from "../components/SEO";

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleOpenPopup = (product) => {
    if (!product.link) {
      setSelectedProduct(product);
    }
  };

  const handleClosePopup = () => {
    setSelectedProduct(null);
  };

  const productsData = [
    {
      title: "EdVedha - LMS",
      image: "./images/EdVedha-Logo.png",
      info: "DBS EdVedha is a modern Learning Management System designed to bridge the gap between teaching and learning through high-end automation and user-friendly features.",
      link: "/edvedha",
      icon: <GraduationCap size={24} />,
      brief: "Transforming education through automated learning paths and smart student tracking."
    },
    {
      title: "UNIcode - Exam Suite",
      image: "./images/UNICode.png",
      info: "UNIcode manages end-to-end exam workflows across universities, ensuring security, transparency, and efficiency in large-scale assessments.",
      link: "/unicode",
      icon: <BookOpen size={24} />,
      brief: "The ultimate university suite for secure, end-to-end examination ecosystem management."
    },
    {
      title: "iCampus BEAT",
      image: "./images/icampus_Beat.png",
      info: "A digital examination system supporting OMR processing, instant results generation, and deep analytical reports.",
      link: "/icampusbeat",
      icon: <Cpu size={24} />,
      brief: "Next-gen examination automation with advanced OMR processing and digital evaluation."
    },
    {
      title: "iCampus BOAT - ERP",
      image: "./images/icampus_Boat.png",
      info: "iCampus BOAT streamlines institution-wide operations from admissions to finance, providing a unified platform for governance.",
      link: "/icampus-boat",
      icon: <Settings size={24} />,
      brief: "A comprehensive Enterprise Resource Planning system for institutional excellence."
    },
    {
      title: "Skill Ascent",
      image: "https://skillascent.in/images/logo.png",
      info: "Skill Ascent is an EdTech and career development platform dedicated to bridging the gap between academic learning and industry requirements through expert-led training and placement support.",
      link: "https://skillascent.in",
      icon: <Settings size={24} />,
      brief: "Empowering students and professionals through industry-ready skill advancement programs and placement support."
    },
    {
      title: "Dbans",
      image: "./images/dbans.jpg",
      info: "Dbans is our specialized digital marketing product designed to enhance brand visibility and engagement through strategic online campaigns, data-driven insights, and creative content delivery.",
      link: "https://dbanscorporate.com/",
      icon: <Megaphone size={24} />,
      brief: "Empowering brand growth through specialized digital marketing and strategic audience engagement."
    },
  ];

  return (
    <div className="products-page-wrapper">
      <SEO
        title="Our Products & Innovations — D Base Solutions Pvt Ltd"
        description="Discover our suite of software products: EdVedha LMS, UNIcode Exam Suite, iCampus BEAT, iCampus BOAT ERP, Skill Ascent, and Dbans."
        keywords="D Base Solutions products, EdVedha, UNIcode, iCampus BEAT, iCampus BOAT, Skill Ascent, Dbans, examination software, educational ERP"
        canonical="https://dbasesolutions.in/products"
        ogImage="/og-products.png"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Products", url: "/products" }
        ]}
      />
      {/* Background Shapes */}
      <div className="products-bg-shape shape-blue"></div>
      <div className="products-bg-shape shape-orange"></div>
      <div className="products-bg-shape shape-purple"></div>

      {/* Header Section */}
      <div className="products-header">
        <h1 className="products-main-title">Our Innovations</h1>
        <p className="products-subtitle">Empowering the future with cutting-edge software solutions designed for excellence.</p>
      </div>

      {/* Creative Grid */}
      <div className="products-creative-grid">
        {productsData.map((product, index) => (
          product.link ? (
            <Link
              to={product.link}
              key={index}
              className="professional-product-card"
            >
              <div className="creative-image-box">
                <img src={product.image} alt={product.title} className="product-display-img" />
                <div className="product-icon-overlay">
                  {product.icon}
                </div>
              </div>
              <h3 className="product-card-title">{product.title}</h3>
              <p className="product-card-brief">{product.brief}</p>
              <div className="product-card-action">
                View Details <ArrowRight size={18} />
              </div>
            </Link>
          ) : (
            <div
              key={index}
              className="professional-product-card"
              onClick={() => handleOpenPopup(product)}
            >
              <div className="creative-image-box">
                <img src={product.image} alt={product.title} className="product-display-img" />
                <div className="product-icon-overlay">
                  {product.icon}
                </div>
              </div>
              <h3 className="product-card-title">{product.title}</h3>
              <p className="product-card-brief">{product.brief}</p>
              <div className="product-card-action">
                Learn More <ArrowRight size={18} />
              </div>
            </div>
          )
        ))}
      </div>

      {/* Premium Glass Popup */}
      {selectedProduct && (
        <div className="glass-popup-overlay" onClick={handleClosePopup}>
          <div
            className="premium-popup-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="popup-close-btn" onClick={handleClosePopup}>
              <X size={20} color="#333" />
            </button>
            <h2 className="product-popup--title" style={{ color: 'var(--primary-color)' }}>{selectedProduct.title}</h2>
            <div style={{ width: '60px', height: '4px', background: 'var(--primary-color)', margin: '1rem auto 2rem' }}></div>
            <p className="product-popup--info" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>{selectedProduct.info}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
